import React from 'react';
import { Chip } from '@mui/material';
import styles from './status-tag.module.scss';
import classNames from 'classnames';

interface StatusTagProps {
    status: 'active' | 'suspended';
    children?: React.ReactNode;
}

export const StatusTag: React.FC<StatusTagProps> = ({ status, children }) => {
    return (<Chip className={classNames({
        [styles.statusTag]: true, 
        [styles.active]: status === 'active', 
        [styles.suspended]: status === 'suspended'})} label={children ?? status} />
    );
};